// extracted by mini-css-extract-plugin
export default {"checkBox":"checkbox_checkBox__hmMn3","fakeCheckBox":"checkbox_fakeCheckBox__ru1XY","checked":"checkbox_checked__GXCT4","body":"checkbox_body__zCLZW"};